import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ForgotPassword.css';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, 3000);
  };

  const handleSignIn = () => {
    navigate('/login');
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="forgot-password-container">
      <header className="forgot-password-header">
        <button className="back-button" onClick={handleBack} aria-label="Go back">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </header>

      <div className="forgot-password-content">
        <div className="forgot-password-form-wrapper">
          <div className="forgot-password-header-text">
            <h1 className="forgot-password-title">
              Forgot<br />Password
            </h1>
            <div className="header-right">
              <span className="account-text">Have an account?</span>
              <button className="signin-link" onClick={handleSignIn}>Sign In</button>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="forgot-password-form">
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email/Phone number
              </label>
              <input
                id="email"
                type="text"
                className="form-input"
                placeholder="User@gmail.com / +234812345678"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="reset-button">
              Send reset instruction
            </button>
          </form>
        </div>
      </div>

      {showSuccess && (
        <div className="success-notification">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M16.667 5L7.5 14.167L3.333 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Reset instructions sent!</span>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;